export const COUNTDOWN = {
  SECOND: 1000,
  MAX_DAYS: 10,
};